<template>
  <div class="upload-button">
    <label>
      <span
        class="p-button p-component"
        :class="{ 'p-disabled': loading }"
        style="width: unset"
      >
        <input
          type="file"
          name="file"
          ref="files"
          style="display: none"
          :multiple="multiple"
          :accept="accept"
          @input="onUpload()"
          :disabled="loading"
        />
        <span
          class="p-button-icon p-button-icon-left pi pi-fw"
          :class="{ 'pi-spin': loading, 'pi-spinner': loading, 'pi-plus': !loading }"
        ></span>
        {{ label }}
      </span>
    </label>
  </div>
</template>

<script>
export default {
  name: 'AppUploadButton',
  props: {
    label: String,
    maxSize: Number,
    multiple: {
      type: Boolean,
      default: () => true,
    },
    accept: {
      type: String,
      default: () => '*',
    },
    loading: Boolean,
  },
  methods: {
    async onUpload() {
      const files = [];
      for (let file of this.$refs.files.files) {
        if (file.size > this.maxSize) {
          return this.showMaxSizeAlert(file);
        }
        files.push(file);
      }
      this.$emit('upload', { files });
      this.$refs.files.value = null;
    },
    showMaxSizeAlert(file) {
      const sizeInMb = Number((this.maxSize / 1024 / 1024).toFixed(2));
      this.$toast.add({
        severity: 'warn',
        summary: 'Desculpe!',
        detail: `O arquivo "${file.name}" excede o tamanho limite de ${sizeInMb} MB`,
        life: 5000,
      });
    },
  },
};
</script>

<style scoped>
.upload-button >>> * {
  cursor: pointer;
}
</style>